// Vuetify 2 initialization
import Vue from 'vue'
import Vuetify from "vuetify"

// Translation provided by Vuetify (typescript)
import it from 'vuetify/src/locale/it.ts'
import en from 'vuetify/src/locale/en.ts'



Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'md', //Material design icons
    },
    lang: {
        locales: { it, en },
        current: 'it',
    },
});
